/* sg-header: mega menú, cajón móvil y buscador predictivo. Sin textos propios: todo viene del markup. */
if (!customElements.get('sg-header')) {
  class SgHeader extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.openTab = null;
      this.searchTimer = null;
      this.abort = null;

      this.input = this.querySelector('[data-sg-search-input]');
      this.panel = this.querySelector('[data-sg-search-panel]');
      this.empty = this.querySelector('[data-sg-search-empty]');
      this.results = this.querySelector('[data-sg-search-results]');
      this.all = this.querySelector('[data-sg-search-all]');
      this.clear = this.querySelector('[data-sg-search-clear]');
      this.scope = { model: '', modelTag: '', type: '' };
      this.modelsView = this.querySelector('[data-sg-models]');
      this.allModels = [...this.querySelectorAll('[data-sg-model]')].map((b) => ({ name: b.dataset.sgModel, tag: b.dataset.tag }));
      this.facets = { models: this.allModels, types: [] };
      this.filtersOpen = false;
      this.last = null;
      this.recent = this.querySelector('[data-sg-search-recent]');
      this.drawer = this.querySelector('[data-sg-drawer]');
      this.scrim = this.querySelector('[data-sg-scrim]');
      this.burger = this.querySelector('[data-sg-drawer-open]');

      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('mouseover', (e) => this.onHover(e));
      this.addEventListener('mouseleave', () => this.desktop.matches && this.closeTabs());
      this.addEventListener('keydown', (e) => e.key === 'Escape' && this.closeAll(true));
      document.addEventListener('click', (e) => !this.contains(e.target) && this.closeAll(false));
      this.desktop.addEventListener('change', () => this.closeAll(false));

      if (this.input) {
        this.input.addEventListener('focus', () => this.openSearch());
        this.input.addEventListener('input', () => this.onSearchInput());
        this.input.addEventListener('keydown', (e) => this.onSearchKey(e));
        this.panel.addEventListener('keydown', (e) => this.onSearchKey(e));
        const form = this.input.closest('form');
        if (form) form.addEventListener('submit', () => this.saveRecent(this.input.value));
        this.panel.addEventListener('click', (e) => {
          const link = e.target.closest('[data-sg-save]');
          if (link) this.saveRecent(link.dataset.sgSave);
          if (e.target.closest('[data-sg-recent-clear]')) {
            this.storeRecent([]);
            this.renderRecent();
          }
          if (e.target.closest('[data-sg-models-toggle]')) return this.toggleModels();
          const model = e.target.closest('[data-sg-model]');
          if (model) {
            this.showModels(false);
            this.filtersOpen = false;
            this.applyFilter('model', model.dataset.sgModel, model.dataset.tag);
            return;
          }
          const toggle = e.target.closest('[data-sg-filter-toggle]');
          if (toggle) {
            this.filtersOpen = !this.filtersOpen;
            if (this.last) this.renderResults(...this.last);
            return;
          }
          const chip = e.target.closest('[data-sg-filter]');
          if (chip) this.applyFilter(chip.dataset.sgFilter, chip.dataset.value || '', chip.dataset.tag || '');
          if (e.target.closest('[data-sg-scope-clear]')) this.applyFilter('all', '', '');
        });
        const toggleBtn = this.querySelector('[data-sg-models-toggle]');
        if (toggleBtn) toggleBtn.addEventListener('click', () => this.toggleModels());
        const find = this.querySelector('[data-sg-models-find]');
        if (find) find.addEventListener('input', () => this.findModels(find.value));
        if (this.clear) {
          this.clear.addEventListener('click', () => {
            this.input.value = '';
            this.clear.hidden = true;
            this.scope = { model: '', modelTag: '', type: '' };
            this.facets = { models: this.allModels, types: [] };
            this.filtersOpen = false;
            this.renderEmptyState();
            this.input.focus();
          });
          if (this.input.value.trim()) this.clear.hidden = false;
        }
      }
    }

    onClick(e) {
      const tab = e.target.closest('[data-sg-tab]');
      if (tab) return this.toggleTab(tab.dataset.sgTab);

      const group = e.target.closest('[data-sg-group]');
      if (group) return this.showGroup(group);

      if (e.target.closest('[data-sg-drawer-open]')) return this.setDrawer(true);
      if (e.target.closest('[data-sg-drawer-close]')) return this.setDrawer(false);

      const acc = e.target.closest('[data-sg-acc]');
      if (acc) {
        const open = acc.getAttribute('aria-expanded') === 'true';
        acc.setAttribute('aria-expanded', String(!open));
        acc.nextElementSibling.hidden = open;
      }
    }

    onHover(e) {
      if (!this.desktop.matches) return;
      const tab = e.target.closest('[data-sg-tab]');
      if (tab && tab.dataset.sgTab !== this.openTab) return this.toggleTab(tab.dataset.sgTab, true);
      const group = e.target.closest('[data-sg-group]');
      if (group) return this.showGroup(group);
      const row = e.target.closest('[data-sg-row]');
      if (row) this.showMedia(row.closest('[data-sg-mega]'), row.dataset.sgRow, row.dataset.sgRow.split('-')[0]);
    }

    toggleTab(id, forceOpen) {
      const isOpen = this.openTab === id;
      this.closeSearch();
      this.closeTabs();
      if (isOpen && !forceOpen) return;
      const tab = this.querySelector(`[data-sg-tab="${id}"]`);
      const mega = this.querySelector(`[data-sg-mega="${id}"]`);
      if (!tab || !mega) return;
      tab.setAttribute('aria-expanded', 'true');
      mega.hidden = false;
      this.scrim.hidden = false;
      this.openTab = id;
    }

    closeTabs() {
      this.querySelectorAll('[data-sg-tab][aria-expanded="true"]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('[data-sg-mega]').forEach((m) => (m.hidden = true));
      if (this.scrim) this.scrim.hidden = true;
      this.openTab = null;
    }

    showGroup(btn) {
      const mega = btn.closest('[data-sg-mega]');
      mega.querySelectorAll('[data-sg-group]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      mega.querySelectorAll('[data-sg-panel]').forEach((p) => (p.hidden = p.dataset.sgPanel !== btn.dataset.sgGroup));
      this.showMedia(mega, btn.dataset.sgGroup);
    }

    // Muestra la imagen de `key`; si no existe, la del grupo `fallbackKey`.
    showMedia(mega, key, fallbackKey = key) {
      const items = mega.querySelectorAll('[data-sg-media]');
      const target = mega.querySelector(`[data-sg-media="${key}"]`) || mega.querySelector(`[data-sg-media="${fallbackKey}"]`);
      if (!target) return;
      items.forEach((m) => (m.hidden = m !== target));
    }

    setDrawer(open) {
      if (!this.drawer) return;
      this.drawer.hidden = !open;
      this.burger.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) this.drawer.querySelector('[data-sg-drawer-close]').focus();
      else this.burger.focus();
    }

    openSearch() {
      this.closeTabs();
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      if (!this.input.value.trim()) this.renderRecent();
    }

    closeSearch() {
      if (!this.panel) return;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }

    closeAll(returnFocus) {
      this.closeTabs();
      this.closeSearch();
      if (this.drawer && !this.drawer.hidden) this.setDrawer(false);
      else if (returnFocus && this.input === document.activeElement) this.input.blur();
    }

    onSearchInput() {
      clearTimeout(this.searchTimer);
      if (this.modelsView && !this.modelsView.hidden) this.showModels(false);
      const q = this.input.value.trim();
      if (this.clear) this.clear.hidden = !q;
      if (!q) return this.renderEmptyState();
      this.showLoading();
      this.searchTimer = setTimeout(() => this.fetchSuggestions(q), 180);
    }

    renderEmptyState() {
      if (this.abort) this.abort.abort();
      this.renderRecent();
      this.empty.hidden = false;
      this.results.hidden = true;
      this.all.hidden = true;
    }

    showLoading() {
      const root = this.results;
      root.replaceChildren();
      root.className = 'sg-search__results';
      const main = document.createElement('div');
      main.className = 'sg-search__main';
      const grid = document.createElement('div');
      grid.className = 'sg-search__grid';
      for (let i = 0; i < 4; i += 1) {
        const card = document.createElement('div');
        card.className = 'sg-search__skel';
        card.append(document.createElement('span'), document.createElement('i'), document.createElement('i'));
        grid.append(card);
      }
      main.append(grid);
      root.append(main);
      this.empty.hidden = true;
      root.hidden = false;
      this.all.hidden = true;
    }

    /* ---- Búsquedas recientes (solo en este navegador) ---- */
    readRecent() {
      try {
        return JSON.parse(localStorage.getItem('sg-recent-search') || '[]').filter(Boolean).slice(0, 6);
      } catch (e) {
        return [];
      }
    }

    storeRecent(list) {
      try {
        localStorage.setItem('sg-recent-search', JSON.stringify(list));
      } catch (e) {
        /* sin almacenamiento */
      }
    }

    saveRecent(term) {
      const t = String(term || '').trim();
      if (t.length < 2) return;
      const list = [t, ...this.readRecent().filter((x) => x.toLowerCase() !== t.toLowerCase())].slice(0, 6);
      this.storeRecent(list);
    }

    renderRecent() {
      if (!this.recent) return;
      const list = this.readRecent();
      this.recent.replaceChildren();
      if (!list.length) {
        this.recent.hidden = true;
        return;
      }
      const head = document.createElement('div');
      head.className = 'sg-search__recent-head';
      head.append(this.label(this.dataset.recentLabel || ''));
      const wipe = document.createElement('button');
      wipe.type = 'button';
      wipe.className = 'sg-search__recent-clear';
      wipe.dataset.sgRecentClear = '';
      wipe.textContent = this.dataset.recentClear || '';
      head.append(wipe);
      const ul = document.createElement('ul');
      ul.className = 'sg-search__chips';
      const action = this.querySelector('form').action;
      list.forEach((t) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'sg-search__chip';
        a.href = `${action}?q=${encodeURIComponent(t)}&options[prefix]=last`;
        a.dataset.sgNav = '';
        a.append(this.icon('clock'), document.createTextNode(t));
        li.append(a);
        ul.append(li);
      });
      this.recent.append(head, ul);
      this.recent.hidden = false;
    }

    async fetchSuggestions(q) {
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      const parts = [q];
      if (this.scope.type) parts.push(this.scope.type);
      if (this.scope.modelTag) parts.push(`tag:"${this.scope.modelTag}"`);
      const params = new URLSearchParams({
        q: parts.join(' '),
        'resources[type]': 'product,collection,query',
        'resources[limit]': '8',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
      });
      try {
        const res = await fetch(`${this.dataset.searchUrl}.json?${params}`, { signal: this.abort.signal });
        if (!res.ok) return;
        const data = (await res.json()).resources.results;
        let products = (data.products || []).filter((p) => p.featured_image && p.featured_image.url);
        if (!this.scope.modelTag && !this.scope.type) this.collectFacets(products);
        if (this.scope.type) {
          const want = this.norm(this.scope.type);
          const same = products.filter((p) => this.norm(p.type) === want);
          if (same.length) products = same;
        }
        this.last = [q, products, data.collections || [], data.queries || []];
        this.renderResults(...this.last);
      } catch (err) {
        if (err.name !== 'AbortError') console.error(err);
      }
    }

    toggleModels() {
      const open = this.modelsView ? this.modelsView.hidden : false;
      this.openSearch();
      this.showModels(open);
      if (open) {
        const find = this.querySelector('[data-sg-models-find]');
        if (find) { find.value = ''; this.findModels(''); }
      }
    }

    showModels(open) {
      if (!this.modelsView) return;
      this.modelsView.hidden = !open;
      const btn = this.querySelector('[data-sg-models-toggle]');
      if (btn) {
        btn.setAttribute('aria-expanded', String(open));
        btn.classList.toggle('is-on', open);
      }
      if (open) {
        this.empty.hidden = true;
        this.results.hidden = true;
        this.all.hidden = true;
      } else if (this.input.value.trim() || this.scope.modelTag || this.scope.type) {
        this.results.hidden = false;
        this.all.hidden = !(this.last && this.last[1].length);
      } else {
        this.empty.hidden = false;
      }
    }

    findModels(text) {
      const q = this.norm(text);
      let shown = 0;
      this.querySelectorAll('[data-sg-models-list] li').forEach((li) => {
        const hit = !q || this.norm(li.textContent).includes(q);
        li.hidden = !hit;
        if (hit) shown += 1;
      });
      const none = this.querySelector('[data-sg-models-none]');
      if (none) none.hidden = shown > 0;
    }

    norm(text) {
      return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    /* Modelos (etiqueta con prefijo) y tipos de producto que aparecen en los resultados. */
    collectFacets(products) {
      const prefix = this.norm(this.dataset.modelPrefix || 'Mod:');
      const models = new Map();
      const types = new Map();
      products.forEach((p) => {
        const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
        tags.forEach((t) => {
          const raw = String(t).trim();
          if (prefix && this.norm(raw).startsWith(prefix)) {
            const name = raw.slice(prefix.length).trim();
            if (name) models.set(name, raw);
          }
        });
        if (p.type) types.set(p.type, (types.get(p.type) || 0) + 1);
      });
      this.facets = {
        models: this.allModels.length ? this.allModels : [...models.entries()].map(([name, tag]) => ({ name, tag })),
        types: [...types.entries()].map(([name, n]) => ({ name, n })).sort((a, b) => b.n - a.n),
      };
    }

    applyFilter(kind, value, tag) {
      if (kind === 'model') {
        const same = this.scope.model === value;
        this.scope.model = same ? '' : value;
        this.scope.modelTag = same ? '' : tag;
      } else if (kind === 'type') {
        this.scope.type = this.scope.type === value ? '' : value;
      } else {
        this.scope = { model: '', modelTag: '', type: '' };
      }
      const q = this.input.value.trim();
      if (!q && !this.scope.modelTag && !this.scope.type) return this.renderEmptyState();
      this.showLoading();
      this.fetchSuggestions(q);
    }

    filterChip(kind, label, value, active, tag, count) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `sg-search__fchip${active ? ' is-on' : ''}`;
      b.dataset.sgFilter = kind;
      b.dataset.value = value;
      if (tag) b.dataset.tag = tag;
      b.dataset.sgNav = '';
      b.setAttribute('aria-pressed', String(active));
      b.append(document.createTextNode(label));
      if (count) {
        const n = document.createElement('i');
        n.textContent = count;
        b.append(n);
      }
      return b;
    }

    buildBar() {
      const bar = document.createElement('div');
      bar.className = 'sg-search__bar';
      const top = document.createElement('div');
      top.className = 'sg-search__bar-top';
      top.append(this.label(this.dataset.productsLabel || ''));

      const active = [this.scope.model, this.scope.type].filter(Boolean);
      const hasFacets = this.facets.models.length > 0 || this.facets.types.length > 1 || active.length > 0;
      if (hasFacets) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `sg-search__filter-btn${this.filtersOpen || active.length ? ' is-on' : ''}`;
        btn.dataset.sgFilterToggle = '';
        btn.setAttribute('aria-expanded', String(this.filtersOpen));
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('width', '16');
        svg.setAttribute('height', '16');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '1.8');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('aria-hidden', 'true');
        svg.innerHTML = '<path d="M4 7h10M18 7h2M4 17h2M10 17h10"></path><circle cx="16" cy="7" r="2"></circle><circle cx="8" cy="17" r="2"></circle>';
        btn.append(svg, document.createTextNode(this.dataset.filterLabel || ''));
        if (active.length) {
          const n = document.createElement('i');
          n.textContent = String(active.length);
          btn.append(n);
        }
        top.append(btn);
      }
      bar.append(top);

      if (active.length) {
        const row = document.createElement('div');
        row.className = 'sg-search__scope';
        const intro = document.createElement('span');
        intro.textContent = this.dataset.scopeLabel || '';
        row.append(intro);
        if (this.scope.model) row.append(this.filterChip('model', `${this.dataset.modelLabel || ''} ${this.scope.model}`, this.scope.model, true, this.scope.modelTag));
        if (this.scope.type) row.append(this.filterChip('type', this.scope.type, this.scope.type, true, ''));
        const wipe = document.createElement('button');
        wipe.type = 'button';
        wipe.className = 'sg-search__recent-clear';
        wipe.dataset.sgScopeClear = '';
        wipe.textContent = this.dataset.scopeClear || '';
        row.append(wipe);
        bar.append(row);
      }

      if (this.filtersOpen) {
        const panel = document.createElement('div');
        panel.className = 'sg-search__filters';
        if (this.facets.models.length) {
          const g = document.createElement('div');
          g.append(this.label(this.dataset.modelTitle || ''));
          const row = document.createElement('div');
          row.className = 'sg-search__fchips';
          this.facets.models.forEach((m) => row.append(this.filterChip('model', m.name, m.name, this.scope.model === m.name, m.tag)));
          g.append(row);
          panel.append(g);
        }
        if (this.facets.types.length > 1) {
          const g = document.createElement('div');
          g.append(this.label(this.dataset.typeTitle || ''));
          const row = document.createElement('div');
          row.className = 'sg-search__fchips';
          this.facets.types.forEach((t) => row.append(this.filterChip('type', t.name, t.name, this.scope.type === t.name, '', t.n)));
          g.append(row);
          panel.append(g);
        }
        bar.append(panel);
      }
      return bar;
    }

    money(value) {
      const n = Number(value);
      if (Number.isNaN(n)) return '';
      return new Intl.NumberFormat(this.dataset.locale || undefined, {
        style: 'currency',
        currency: this.dataset.currency || 'MXN',
        maximumFractionDigits: 0,
      }).format(n);
    }

    /* Resalta en negritas lo que coincide con lo escrito, sin usar innerHTML. */
    highlight(text, q) {
      const frag = document.createDocumentFragment();
      const words = q
        .split(/\s+/)
        .filter((w) => w.length > 1)
        .map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (!words.length) {
        frag.append(document.createTextNode(text));
        return frag;
      }
      const re = new RegExp(`(${words.join('|')})`, 'ig');
      text.split(re).forEach((part, i) => {
        if (!part) return;
        if (i % 2 === 1) {
          const b = document.createElement('b');
          b.textContent = part;
          frag.append(b);
        } else {
          frag.append(document.createTextNode(part));
        }
      });
      return frag;
    }

    icon(name) {
      const paths = {
        search: '<circle cx="11" cy="11" r="6.5"></circle><path d="M20 20l-4-4"></path>',
        clock: '<circle cx="12" cy="12" r="8.5"></circle><path d="M12 7.5V12l3 2"></path>',
        arrow: '<path d="M9 6l6 6-6 6"></path>',
      };
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '16');
      svg.setAttribute('height', '16');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.8');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      svg.innerHTML = paths[name] || '';
      return svg;
    }

    list(items, cls, build) {
      const ul = document.createElement('ul');
      ul.className = cls;
      items.forEach((item) => {
        const li = document.createElement('li');
        li.append(build(item));
        ul.append(li);
      });
      return ul;
    }

    renderResults(q, products, collections, queries) {
      const root = this.results;
      root.replaceChildren();
      root.className = 'sg-search__results';

      const hasRail = collections.length > 0 || queries.length > 0;

      if (hasRail) {
        const rail = document.createElement('div');
        rail.className = 'sg-search__rail';
        if (queries.length) {
          const sec = document.createElement('div');
          sec.append(
            this.label(this.dataset.queriesLabel || ''),
            this.list(queries.slice(0, 5), 'sg-search__sugs', (item) => {
              const a = document.createElement('a');
              a.href = item.url;
              a.dataset.sgNav = '';
              a.dataset.sgSave = item.text;
              const span = document.createElement('span');
              span.append(this.highlight(item.text, q));
              a.append(this.icon('search'), span);
              return a;
            })
          );
          rail.append(sec);
        }
        if (collections.length) {
          const sec = document.createElement('div');
          sec.append(
            this.label(this.dataset.catsLabel || ''),
            this.list(collections.slice(0, 4), 'sg-search__sugs sg-search__sugs--cats', (c) => {
              const a = document.createElement('a');
              a.href = c.url;
              a.dataset.sgNav = '';
              const span = document.createElement('span');
              span.append(this.highlight(c.title, q));
              a.append(span, this.icon('arrow'));
              return a;
            })
          );
          rail.append(sec);
        }
        root.append(rail);
      }

      const main = document.createElement('div');
      main.className = 'sg-search__main';
      if (products.length) {
        main.append(this.buildBar());

        const tagStar = this.dataset.tagStar;
        const tagOtono = this.dataset.tagOtono;
        const grid = document.createElement('div');
        grid.className = `sg-search__grid${hasRail ? ' sg-search__grid--rail' : ''}`;
        products.forEach((p) => {
          const tags = (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).map((t) => String(t).trim().toLowerCase());
          let mode = 'plain';
          if (tagStar && tags.includes(tagStar)) mode = 'expo';
          else if (tagOtono && tags.includes(tagOtono)) mode = 'otono';
          const price = Number(p.price);
          const was = Number(p.compare_at_price);
          const off = was > price && price > 0 ? Math.round((1 - price / was) * 100) : 0;

          const a = document.createElement('a');
          a.className = 'sg-search__card';
          a.href = p.url;
          a.dataset.sgNav = '';
          a.dataset.sgSave = q;

          const thumb = document.createElement('span');
          thumb.className = 'sg-search__thumb';
          const src = p.featured_image && p.featured_image.url;
          if (src) {
            const img = document.createElement('img');
            img.src = src;
            img.alt = '';
            img.loading = 'lazy';
            thumb.append(img);
          }
          if (off > 0) {
            const badge = document.createElement('span');
            badge.className = `sg-search__off sg-search__off--${mode}`;
            badge.textContent = `−${off}%`;
            thumb.append(badge);
          }

          const name = document.createElement('span');
          name.className = 'sg-search__card-name';
          name.append(this.highlight(p.title, q));

          const row = document.createElement('span');
          row.className = `sg-search__card-price sg-search__card-price--${mode}`;
          if (p.available === false) {
            const sold = document.createElement('span');
            sold.className = 'sg-search__sold';
            sold.textContent = this.dataset.soldoutText || '';
            row.append(sold);
          } else {
            const now = document.createElement('b');
            now.textContent = this.money(p.price);
            row.append(now);
            if (off > 0) {
              const old = document.createElement('s');
              old.textContent = this.money(p.compare_at_price);
              row.append(old);
            }
          }
          a.append(thumb, name, row);
          grid.append(a);
        });
        main.append(grid);
      } else {
        if (this.scope.model || this.scope.type) main.append(this.buildBar());
        const none = document.createElement('div');
        none.className = 'sg-search__none';
        const msg = document.createElement('p');
        msg.className = 'sg-search__none-title';
        msg.textContent = `${this.dataset.emptyText} “${q}”`;
        const hint = document.createElement('p');
        hint.className = 'sg-search__none-hint';
        hint.textContent = this.dataset.hintText || '';
        none.append(msg, hint);
        const trends = [...this.querySelectorAll('.sg-search__trending a')];
        if (trends.length) {
          none.append(
            this.list(trends, 'sg-search__chips', (t) => {
              const a = document.createElement('a');
              a.className = 'sg-search__chip';
              a.href = t.href;
              a.dataset.sgNav = '';
              a.textContent = (t.querySelector('.sg-search__trend-t') || t).textContent.trim();
              return a;
            })
          );
        }
        main.append(none);
      }
      root.append(main);

      this.empty.hidden = true;
      root.hidden = false;
      this.all.hidden = !products.length;
      this.all.dataset.sgSave = q;
      this.all.href = `${this.querySelector('form').action}?q=${encodeURIComponent(q)}&options[prefix]=last`;
      this.all.querySelector('[data-sg-search-term]').textContent = `“${q}”`;
    }

    /* Flechas para recorrer los resultados; Enter abre el enlace enfocado. */
    onSearchKey(e) {
      if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;
      const items = [...this.panel.querySelectorAll('[data-sg-nav]')].filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const idx = items.indexOf(document.activeElement);
      const forward = e.key === 'ArrowDown' || e.key === 'ArrowRight';
      if (document.activeElement === this.input) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          items[0].focus();
        }
        return;
      }
      e.preventDefault();
      if (!forward && idx <= 0) {
        this.input.focus();
        return;
      }
      items[forward ? Math.min(items.length - 1, idx + 1) : idx - 1].focus();
    }

    label(text) {
      const p = document.createElement('p');
      p.className = 'sg-label';
      p.textContent = text;
      return p;
    }
  }

  customElements.define('sg-header', SgHeader);
}
